import { useEffect } from 'react';

export const useContentViewerActiveClass = (): void => {
  useEffect(() => {
    const contentElement = document.querySelector('.content');

    if (contentElement) {
      contentElement.classList.add('content-viewer-active');

      return () => {
        contentElement.classList.remove('content-viewer-active');
      };
    }
  }, []);
};
